<template>
  <div id="home">
    <menu-default/>
    <!-- Masthead -->
    <header class="masthead text-white text-center">
      <div class="overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col-xl-9 mx-auto">
            <h1 class="mb-5">Soluções em publicações <br/>técnicas aeronáuticas</h1>
          </div>
          <div class="col-md-12 col-lg-12 col-xl-12">
            <form>
              <div class="form-row justify-content-center">
                <a @click="redirectURL({name: 'publications'})" class="btn btn-lg btn-primary">Comprar publicação</a>
                <span style="margin: 20px"></span>
                <a @click="redirectURL({name: 'manage'})" class="btn btn-lg btn-primary">Gerenciar publicação</a>
                <span style="margin: 20px"></span>
                <a v-bind:href="media_ip + status.file" target="_blank" class="btn btn-lg btn-primary">Status das publicações</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </header>

    <!-- Icons Grid -->
    <section class="features-icons bg-light text-center">
      <div class="container">
        <div class="row">
          <div class="col-lg-4">
            <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
              <div class="features-icons-icon d-flex">
                <i class="icon-doc m-auto text-primary"></i>
              </div>
              <h3>Adquira sua publicação</h3>
              <p class="lead mb-0">Compre publicações online rapidamente e garanta sua assinatura</p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
              <div class="features-icons-icon d-flex">
                <i class="icon-calendar m-auto text-primary"></i>
              </div>
              <h3>Fique atualizado</h3>
              <p class="lead mb-0">O sistema avisa automaticamente sobre atualizações na publicação</p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="features-icons-item mx-auto mb-0 mb-lg-3">
              <div class="features-icons-icon d-flex">
                <i class="icon-check m-auto text-primary"></i>
              </div>
              <h3>Gerencie sua assinatura</h3>
              <p class="lead mb-0">Gerencie sua assinatura com rapidez e não fique desatualizado</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Image Showcases -->
    <section class="showcase" style="background: #fff; border-bottom: solid 1px #d6d7d8;">
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-lg-6 text-white showcase-img" style="background-image: url('/img/pubtec_airplane_2.jpg');"></div>
          <div class="col-lg-6 my-auto showcase-text">
            <h2>Quem somos</h2>
            <p class="lead mb-0">
              Fundada em 1997, a PUBTEC é hoje a empresa responsável pela edição, revisão, reprodução e comercialização das publicações técnicas de todas as aeronaves produzidas pela Embraer.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Call to Action -->
    <section class="call-to-action text-white text-center">
      <div class="container">
        <div class="row">
          <div class="col-xl-9 mx-auto">
            <h2 class="mb-4">
              
            </h2>
          </div>
        </div>
      </div>
    </section>
    <footer-default/>
  </div>
</template>

<script>
  import menuDefault from "./common/menu-default"
  import footerDefault from "./common/footer-default"
  import mixins from "../helpers/mixins"
  import publication from "../api/publication"
  import { CONFIGS } from '../configs'

  export default {
    name: 'Home',
    data () {
      return {
        status: '',
        loading: true,
        media_ip: CONFIGS.PUB_MEDIA_IP
      }
    },
    mixins: [mixins],
    components: { menuDefault, footerDefault },
    methods: {
      redirectURL(path) {
        this.$router.push(path)
        return false
      },
      getStatus(){
        publication.get_status().then((response) => {
          this.status = response.data
          this.loading = false
        })
      }
    },
    mounted(){
      this.getStatus()
    }
  }
</script>

<style scoped>
  header.masthead{
    background-image: url('/img/ipanema.jpg');
  }
  section.call-to-action{
    background: transparent;
    padding-top: 4rem;
    padding-bottom: 0rem;
  }
</style>
